import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';
import { PatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom } from './ShortTermGoalDetailCustom';
import { bindActionCreators } from 'redux';
import { AddButton } from '_components';
import { noteActions } from '_actions';

class PatientCareCenterNoteGoalsGoalShortTermGoals extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: '-1',
        }
    };

    addCustomGoal() {
        if (this.state.selectedDate !== '-1' && this.state.selectedDate !== '0') {
            var goalDate = new Date();
            goalDate.setDate(goalDate.getDate() + parseInt(this.state.selectedDate));
            this.props.addCustomSTGoal(this.props.noteId, goalDate.toISOString().split('T')[0]);
        } else {
            this.props.addCustomSTGoal(this.props.noteId);
        }
        if (!this.props.goalsUpdated && this.props.noteType !== 1) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }


    render() {
        return (
            <div className={styles.stg_header_wrapper}>
                <div className={styles.stg_header_row}>
                <span className={styles.add_button_wrapper}>
                    {this.props.noteType !== 2 && <AddButton size='extra-small' title={'Add Short Term Goal'} onClick={() => this.addCustomGoal()} />}
                        </span>
                    <div className={styles.stg_header_1}>Short Term Goals</div>
                    {this.props.noteType !== 1 && <div className={styles.stg_header_1_1}>progress</div>}
                </div>
         
                {Object.keys(this.props.stg_custom)
                    .map(key => {
                        const result = this.props.stg_custom[key];
                        return (
                            <PatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom id={result.SGNO} key={result.SGNO} />
                        )
                    })
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        addCustomSTGoal: bindActionCreators(noteActions.addCustomSTGoal, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stg = Object.keys(state.entities.notes.PTSHORTGOALS)
        .filter(key => {
            return (state.entities.notes.PTSHORTGOALS[key].NoteId === noteId && !state.entities.notes.PTSHORTGOALS[key].SGCUSTOM);
        })
        .sort((a, b) => { return state.entities.notes.PTSHORTGOALS[a].SGNO - state.entities.notes.PTSHORTGOALS[b].SGNO; })
        .map(key => state.entities.notes.PTSHORTGOALS[key]);


    let stg_custom = Object.keys(state.entities.notes.PTSHORTGOALS)
        .filter(key => {
            return (state.entities.notes.PTSHORTGOALS[key].NoteId === noteId && state.entities.notes.PTSHORTGOALS[key].SGCUSTOM && state.entities.notes.PTSHORTGOALS[key].SGACTIVE);
        })
        .sort((a, b) => { return state.entities.notes.PTSHORTGOALS[a].SGNO - state.entities.notes.PTSHORTGOALS[b].SGNO; })
        .map(key => state.entities.notes.PTSHORTGOALS[key]);

    return {
        noteId,
        noteType,
        pk,
        stg,
        stg_custom,
    };
}

const connectedPatientCareCenterNoteGoalsGoalShortTermGoals = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalShortTermGoals);
export { connectedPatientCareCenterNoteGoalsGoalShortTermGoals as PatientCareCenterNoteGoalsGoalShortTermGoals };

